export const getConnectTeamsButtonProps = (connectedAccountId: number): any => ({
  'data-method': 'post',
  href: `/user/connected_accounts/${connectedAccountId}/grant_teams/`,
  target: 'auth_popup',
  onClick: () => window.open('about:blank', 'auth_popup', 'width=1000,height=800')
});
